import { render, staticRenderFns } from "./registerFour.vue?vue&type=template&id=7b2f2588&scoped=true&"
import script from "./registerFour.vue?vue&type=script&lang=js&"
export * from "./registerFour.vue?vue&type=script&lang=js&"
import style0 from "./registerFour.vue?vue&type=style&index=0&id=7b2f2588&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2f2588",
  null
  
)

export default component.exports